<template>
    <select
        v-bind="$attrs"
        v-model="selectedInternal"
        v-on="inputListeners"
        @change="updateSelected"
        :multiple="multiple"
    >
        <slot name="empty-option" v-if="emptyRow">
            <option :value="emptyValue">{{emptyText}}</option>
        </slot>
        <slot :selected="selected">
            <option
                v-for="(option, key) in optionsConverted"
                v-if="isVisible(option)"
                :key="key"
                :selected="isSelected(option.value)"
                :disabled="isDisabled(option)"
                :value="option.value"
                v-text="option.text"
                v-bind="option.attrs"
            />
        </slot>
    </select>
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'
import OptionsHandlerMixin from '@/components/form/base/helpers/OptionsHandlerMixin'

export default {
    name: 'oc-select-input',
    extends: BaseInputComponent,
    mixins: [OptionsHandlerMixin],
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: [Number, String, Array], // needed for v-model
        useTextAsValue: {
            type: Boolean,
            default: false
        },
        emptyRow: {
            type: Boolean,
            default: true
        },
        emptyText: {
            type: [String, Number],
            default: '-- Please select --'
        },
        emptyValue: {
            type: [String, Number],
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        selected(newVal) {
            this.selectedInternal = newVal
        }
    },
    data() {
        return {
            selectedInternal: this.selected
        }
    },
    methods: {
        updateSelected() {
            this.$emit('input', this.selectedInternal)
        },
        isSelected(value) {
            if( isArray(this.selectedInternal) ) {
                return inArray(value, this.selectedInternal, false)
            }

            return (String(this.selectedInternal) === value) ? 'selected' : ''
        }
    },
    computed: {
        inputListeners() {
            let listeners = BaseInputComponent.computed.inputListeners.call(this)
            // do not forward input event - we will emit it in a custom way in order to support "multiple"
            delete listeners.input
            return listeners
        },
        optionsConverted() {
            let options = OptionsHandlerMixin.computed.optionsConverted.call(this)

            options.forEach( (opt, index) => {
                if( opt.attrs === undefined ) {
                    opt.attrs = {}
                }

                if( this.useTextAsValue && this.options[index].value === undefined ) {
                    opt.value = String(opt.text)
                }
            })

            return options
        }
    },
    mounted() {
        // extract options from slot
        // this can be useful for parent components to access option list
        if( this.options.length === 0 ){
            for(let n in this.$el.children) {
                let item = this.$el.children[n]
                let value = String(item.value)

                if( 'option' === String(item.tagName).toLowerCase() && value !== String(this.emptyValue) ) {

                    let opt = {
                        text: String(item.innerText),
                        value,
                        visible: true,
                        disabled: false,
                        attrs: {}
                    }

                    if( this.useTextAsValue ) {
                        opt.value = opt.text
                    }

                    this.preparedOptions.push( opt )
                }
            }
        }
    }
}
</script>
